const firebaseConfig = {
  apiKey: "AIzaSyDO9ChzGxXiTdd5Pk_FsPVE4HwJMtWqoKk",
  authDomain: "x5-work-out.firebaseapp.com",
  projectId: "x5-work-out",
  storageBucket: "x5-work-out.firebasestorage.app",
  messagingSenderId: "281822760462",
  appId: "1:281822760462:web:4517c3b595ef12bfddf65f",
  measurementId: "G-8G5S977BKK"
};

export default firebaseConfig;
